import { HStack } from '@montel/montelpro-shared-components-v2';
import { Provider } from 'domain/subscription/interfaces/Subscription';
import styled from 'styled-components';

const StyledProviderItem = styled(HStack)<{ $active?: boolean }>`
	padding: 8px;
	border: 1px solid ${({ theme }) => theme.colors.borderBrand};
	border-radius: 4px;
	cursor: pointer;
	pointer-events: ${({ $active }) => ($active ? 'none' : 'auto')};
	background-color: ${({ $active, theme }) =>
		$active ? theme.colors.bgSelected : 'transparent'};

	&:hover {
		background-color: ${({ theme }) => theme.colors.bgHover};
	}
`;

export const ProviderItem: React.FC<{
	provider: Provider;
	onClick: () => void;
	active?: boolean;
}> = ({ provider, onClick, active }) => (
	<StyledProviderItem
		key={provider.code}
		wrap="nowrap"
		gap="sm"
		onClick={onClick}
		$active={active}
	>
		{provider.name} ({provider.code})
	</StyledProviderItem>
);
